import React from "react";
import UserNote from "../../../management/offer/UserNote";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import { SonicDBEntryData } from "../../../../common/classes/SonicDBEntry";
import { SonicUserData } from "../../../../common/classes/SonicUser";
import Status from "../../../../common/management/detail/Status";
import NotificationModal from "../../../../common/settings-modal/NotificationModal";
import styles from "../../../management/db-list/detail/DatabaseDetail.module.scss";
import workStyles from "../../../../features/mypage/user_settings/database_entries/EditWork.module.scss";
import EditWorkItem from "../../../mypage/user_settings/database_entries/EditWorkItem";
import EditWorkModal from "../../../mypage/user_settings/database_entries/EditWorkModal";
import { checkForJikeiRoles } from "../../../../utils/GeneralUtils";
import {
  RequestState,
  genNotificationColor,
  genNotificationMessage,
} from "../../../../utils/RequestState";
import SelenaA from "../../../../assets/img/service/selena-a.webp";
import SonicLink from "../../../../common/routing/SonicLink";

type Props = {
  person: SonicDBEntryData;
  owner: SonicUserData;
  isLoading: boolean;
  selectStatus?: string;
  setSelectStatus: (value: string, name: string) => void;
  handleUpdate: () => void;
  showStatusMenu: boolean;
  handleStatusMenu: () => void;
  isMemoEdit: boolean;
  handleMemoEdit: () => void;
  handleMemoUpdate: () => void;
  setMemo: React.Dispatch<React.SetStateAction<string | undefined>>;
  requestState: RequestState;

  // works
  workNumber: number;
  isModalShown: boolean;
  setWorkNumber: (value: number) => void;
  setIsModalShown: (value: boolean) => void;
};

const JikeiPortfolioDetail: React.FC<Props> = ({
  person,
  owner,
  isLoading,
  selectStatus,
  setSelectStatus,
  handleUpdate,
  showStatusMenu,
  handleStatusMenu,
  isMemoEdit,
  handleMemoEdit,
  handleMemoUpdate,
  setMemo,
  requestState,
  workNumber,
  isModalShown,
  setWorkNumber,
  setIsModalShown,
}) => {
  return (
    <div className={styles["f-databaseDetail"]}>
      {isLoading || requestState === RequestState.Doing || !person || !owner ? (
        <LoadingSpinner space={1} admin_page={true} />
      ) : (
        <>
          <h1 className={styles["f-databaseDetail__title"]}>
            プロフィール詳細
          </h1>
          <div className={styles["f-databaseDetail__inner"]}>
            <div className={styles["f-databaseDetail__head"]}>
              <Status
                isVisibilityStatus={true}
                status={person?.status}
                selectStatus={selectStatus}
                showStatusMenu={showStatusMenu}
                handleStatusMenu={handleStatusMenu}
                setSelectStatus={setSelectStatus}
              />
              <div className={styles["f-databaseDetail__user"]}>
                <div className={styles["f-databaseDetail__user-head"]}>
                  <h2 className={styles["f-databaseDetail__user-head__title"]}>
                    ユーザー情報
                  </h2>
                  <SonicLink
                    to={
                      checkForJikeiRoles(owner?.roles, true)
                        ? `/jikei/manager/${owner?.id}`
                        : `/jikei/student/${owner?.id}`
                    }
                  >
                    ユーザー詳細
                  </SonicLink>
                </div>
                <div className={styles["f-databaseDetail__user-info"]}>
                  <div>
                    <p>ユーザー名</p>
                    <span>{owner?.meta?.full_name}</span>
                  </div>
                  <div>
                    <p>メールアドレス</p>
                    <span>{owner?.meta?.email}</span>
                  </div>
                </div>
              </div>
              <UserNote
                memo={person?.memo}
                isMemoEdit={isMemoEdit}
                handleMemoEdit={handleMemoEdit}
                handleMemoUpdate={handleMemoUpdate}
                setMemo={setMemo}
              />
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                メイン画像
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.imgs?.[0]?.medium?.url ? (
                  <div className={styles["imageBox"]}>
                    <img src={person.imgs[0].medium.url} />
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                プロフィール名
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.name}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                ふりがな
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.kana}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                チーム
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.team?.[0]?.name ? person.team[0].name : "未選択"}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                タイプ
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.player_type?.[0]?.name
                  ? person.player_type[0].name
                  : "未選択"}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                マイゲーム
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.game && person.game.length > 0
                  ? person.game.map((el) => el.name).join(`\n`)
                  : "未選択"}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                プロフィール
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.profile}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                出身地
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.birthplace}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                身長
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.height}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                体重
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.weight}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                趣味
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.hobby}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                X (旧Twitter)
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.sns?.twitter?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Instagram
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.sns?.instagram?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Facebook
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.sns?.facebook?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Youtube
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.sns?.youtube?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                Twitch
              </span>
              <div className={styles["f-databaseDetail__info-content"]}>
                {person?.sns?.twitch?.toString()}
              </div>
            </div>
            <div className={styles["f-databaseDetail__info"]}>
              <span className={styles["f-databaseDetail__info-title"]}>
                活動実績
              </span>
              <div
                className={`${styles["f-databaseDetail__info-content"]} ${styles["vertical"]}`}
              >
                {person?.history?.map((item, i) => (
                  <div
                    key={i}
                    className={
                      styles["f-databaseDetail__info-content__history"]
                    }
                  >
                    <div>{item.year} 年</div>
                    <div>{item.title}</div>
                  </div>
                ))}
              </div>
            </div>
            <div
              className={`${styles["f-databaseDetail__form"]} ${styles["vertical"]}`}
            >
              <span className={styles["f-databaseDetail__form-title"]}>
                作品
              </span>
              <div className={workStyles["edit-work"]}>
                {person?.works?.map((work, i) => (
                  <div key={i} className={workStyles["edit-workItem-wrapper"]}>
                    <EditWorkItem
                      index={i}
                      title={work.title}
                      img_src={work.image || undefined}
                      link={work.link}
                      setIsEditWork={setIsModalShown}
                      setEditWorkNumber={setWorkNumber}
                      deleteWork={() => {}}
                      isPreview={true}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className={styles["f-databaseDetail__btn"]}>
              <button
                className={styles["f-databaseDetail__btn-save"]}
                onClick={() => handleUpdate()}
              >
                保存
              </button>
            </div>

            {isModalShown ? (
              <EditWorkModal
                index={workNumber}
                image={person?.works?.[workNumber]?.image || undefined}
                title={person?.works?.[workNumber]?.title}
                link={person?.works?.[workNumber]?.link}
                description={person?.works?.[workNumber]?.description}
                editWork={() => {}}
                closeHandler={() => setIsModalShown(false)}
                isPreview={true}
              />
            ) : null}
          </div>
        </>
      )}
      {requestState !== RequestState.Waiting ? (
        <NotificationModal
          color={genNotificationColor(requestState)}
          message={genNotificationMessage(requestState)}
          img_src={requestState === RequestState.Success ? SelenaA : undefined}
        />
      ) : null}
    </div>
  );
};

export default JikeiPortfolioDetail;
